import React, { useState } from 'react';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Typography
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import useDocumentService from '../hooks/useDocumentService';
import { useSnackbar } from './SnackbarProvider';
import { handleApiError, IconBtn } from './Utils';

const UploadDocumentButton = ({ to, id, fetch, showDisableDoc }) => {
    const [uploadModalOpen, setUploadModalOpen] = useState(false);
    const [confirmDeleteOpen, setConfirmDeleteOpen] = useState(false);
    const [selectedFile, setSelectedFile] = useState(null);
    const [uploadError, setUploadError] = useState(null);
    const [loading, setLoading] = useState(false);
    const { addDocument, disableDocumentByObjectId } = useDocumentService();
    const showSnackbar = useSnackbar();

    const handleUpload = async () => {
        if (!selectedFile) {
            setUploadError("Por favor selecciona un archivo");
            return;
        }

        const formData = new FormData();
        formData.append('document', selectedFile);
        formData.append(to, id);

        try {
            setLoading(true);
            await addDocument(formData);
            showSnackbar('Documento subido correctamente', 'success');
            fetch();
            setUploadModalOpen(false);
            setSelectedFile(null);
            setUploadError(null);
        } catch (error) {
            const msg = handleApiError(error, 'Error al subir el documento.');
            setUploadError(msg);
            showSnackbar(msg, 'error');
        } finally {
            setLoading(false);
        }
    };

    const handleDisableDocument = async () => {
        const formData = new FormData();
        formData.append(to, id);

        try {
            setLoading(true);
            await disableDocumentByObjectId(formData);
            showSnackbar('Documento eliminado correctamente', 'success');
            fetch();
        } catch (error) {
            showSnackbar(handleApiError(error, 'Error al eliminar el documento.'), 'error');
        } finally {
            setLoading(false);
            setConfirmDeleteOpen(false);
        }
    };

    const handleFileChange = (e) => {
        setSelectedFile(e.target.files[0]);
    };

    return (
        <>
            <Button
                variant="contained"
                color="primary"
                size="small"
                onClick={() => setUploadModalOpen(true)}
                startIcon={<AddIcon />}
                sx={{ marginRight: '10px' }}
            >
                doc
            </Button>

            {showDisableDoc ? (
                <IconBtn
                    icon={<DeleteIcon />}
                    title="Eliminar"
                    color="error"
                    onClick={() => setConfirmDeleteOpen(true)}
                />
            ) : (
                <></>
            )}

            <Dialog open={uploadModalOpen} onClose={() => setUploadModalOpen(false)}>
                <DialogTitle>Subir documento (pdf, word, excel o imagen hasta 20mb)</DialogTitle>
                <DialogContent>
                    <input type="file" onChange={handleFileChange} />
                    {uploadError && (
                        <Typography variant="body2" color="error" style={{ marginTop: 10 }}>
                            {uploadError}
                        </Typography>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setUploadModalOpen(false)} color="primary">
                        Cancelar
                    </Button>
                    <Button
                        onClick={handleUpload}
                        color="primary"
                        variant="contained"
                        disabled={loading}
                    >
                        {loading ? 'Subiendo...' : 'Enviar'}
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog open={confirmDeleteOpen} onClose={() => setConfirmDeleteOpen(false)}>
                <DialogTitle>Confirmar eliminación</DialogTitle>
                <DialogContent>
                    <Typography>¿Estás seguro de que deseas eliminar este documento?</Typography>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setConfirmDeleteOpen(false)} color="primary">
                        Cancelar
                    </Button>
                    <Button
                        onClick={handleDisableDocument}
                        color="secondary"
                        variant="contained"
                        style={{ backgroundColor: 'red' }}
                        disabled={loading}
                    >
                        {loading ? 'Eliminando...' : 'Eliminar'}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default UploadDocumentButton;
